const Header = () => {
  return (
    <header className="flex p-5 justify-center bg-sky-600" role="banner" aria-label="Main header">
      <h1 className="text-4xl font-light text-white">Scriptures</h1>
    </header>
  );
};

export default Header;
